'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, memo } from 'react';
import BaseCard from '@/components/BaseCard';
import CardAwards from '@/components/BaseCard/CardAwards';
import { CaseSlideItem } from '@/components/CasesChunkedSlider/types';
import StrapiRichContent from '@/components/StrapiRichContent';
import { blocksContentToAltText } from '@/lib/blocks-content';
import css from './style.module.scss';
import Tags from './Tags';
interface Props {
  data: CaseSlideItem;
  width?: number;
  className?: string;
  hideDefaultCursor?: boolean;
  withOverlay?: boolean;
  isVisible?: boolean;
}
const CaseSlide: FC<Props> = t0 => {
  const $ = _c(27);
  const {
    data,
    width,
    className,
    hideDefaultCursor: t1,
    withOverlay,
    isVisible
  } = t0;
  const hideDefaultCursor = t1 === undefined ? true : t1;
  const {
    title,
    image,
    videoUrl,
    thumbnailUrl,
    subtitle,
    url,
    tags,
    awards
  } = data;
  const t2 = url || "";
  const t3 = image?.url;
  const t4 = hideDefaultCursor && css.hideDefaultCursor;
  let t5;
  if ($[0] !== className || $[1] !== t4) {
    t5 = clsx(css.caseSlide, className, t4);
    $[0] = className;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== tags) {
    t6 = tags?.length ? <Tags tags={tags} /> : null;
    $[3] = tags;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== awards) {
    t7 = <CardAwards awards={awards} />;
    $[5] = awards;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = isVisible !== false;
  let t9;
  if ($[7] !== image?.alternativeText || $[8] !== subtitle || $[9] !== title) {
    t9 = image?.alternativeText || blocksContentToAltText(title) || subtitle;
    $[7] = image?.alternativeText;
    $[8] = subtitle;
    $[9] = title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== title) {
    t10 = title ? <h3 className={css.title}><StrapiRichContent content={title} /></h3> : null;
    $[11] = title;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== subtitle || $[14] !== t10 || $[15] !== t2 || $[16] !== t3 || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== thumbnailUrl || $[23] !== videoUrl || $[24] !== width || $[25] !== withOverlay) {
    t11 = <BaseCard url={t2} width={width} subtitle={subtitle} videoUrl={videoUrl} thumbnailUrl={thumbnailUrl} imageUrl={t3} className={t5} withOverlay={withOverlay} tags={t6} awards={t7} playing={t8} imageAlt={t9} mainText={t10} />;
    $[13] = subtitle;
    $[14] = t10;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = thumbnailUrl;
    $[23] = videoUrl;
    $[24] = width;
    $[25] = withOverlay;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default memo(CaseSlide);